/**
 * @file 页面数据
 */

export default {
    tab: [
        // {
        //     link: 'https://paddlejs.baidu.com/auth/intro',
        //     text: '鉴权服务'
        // },
        {
            link: 'https://paddlejs.baidu.com/model',
            key: 'model',
            text: '模型库'
        },
        {
            link: 'https://paddlejs.baidu.com/demo',
            key: 'demo',
            text: '案例集'
        },
        {
            link: 'https://paddlejs.baidu.com/doc',
            key: 'doc',
            text: '文档中心'
        }
    ],
    link: [
        {
            title: '资源',
            list: [
                {
                    name: '文档',
                    key: 'doc',
                    url: 'https://paddlejs.baidu.com/doc'
                },
                {
                    name: '模型库',
                    key: 'model',
                    url: 'https://paddlejs.baidu.com/model'
                },
                {
                    name: '案例集',
                    key: 'demo',
                    url: 'https://paddlejs.baidu.com/demo'
                }
            ]
        },
        {
            title: '友情链接',
            list: [
                {
                    name: '飞桨',
                    key: 'paddlepaddle',
                    url: 'https://www.paddlepaddle.org.cn'
                },
                {
                    name: 'AI开放平台',
                    key: 'ai',
                    url: 'https://ai.baidu.com'
                },
                {
                    name: 'AI Studio',
                    key: 'aistudio',
                    url: 'https://aistudio.baidu.com/aistudio/index'
                }
            ]
        },
        {
            title: '联系我们',
            list: [
                {
                    name: 'GitHub',
                    key: 'gitHub',
                    url: 'https://github.com/PaddlePaddle/Paddle.js'
                },
                {
                    name: 'Gitee',
                    key: 'gitee',
                    url: 'https://gitee.com/paddlepaddle/Paddle.js'
                }
            ]
        }
    ]
};
